import { render, staticRenderFns } from "./ieSettingPop.vue?vue&type=template&id=809d01ae&scoped=true"
import script from "./ieSettingPop.vue?vue&type=script&lang=js"
export * from "./ieSettingPop.vue?vue&type=script&lang=js"
import style0 from "./ieSettingPop.vue?vue&type=style&index=0&id=809d01ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "809d01ae",
  null
  
)

export default component.exports